<template>
  <v-container class="pa-6">
    <v-form v-model="valid" ref="itemForm" @submit="item_submit">
      <v-card class="elevation-8 overflow-hidden" style="border-radius: 16px">
        <!-- Header compacto -->
        <v-card-title class="company-header py-4">
          <v-icon left size="28" color="white">mdi-office-building</v-icon>
          <span class="text-h6 font-weight-bold">Configuración de Empresa</span>
        </v-card-title>

        <!-- Navigation tabs compactas -->
        <v-tabs
          v-model="activeTab"
          background-color="white"
          color="primary"
          grow
          height="48"
          class="mb-3"
        >
          <v-tab>
            <v-icon left small>mdi-information</v-icon>
            General
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-calculator</v-icon>
            Fiscal
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-cog</v-icon>
            Config
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-point-of-sale</v-icon>
            Operación
          </v-tab>
        </v-tabs>

        <v-card-text class="pa-5">
          <v-tabs-items v-model="activeTab" class="pt-2">
            <!-- PESTAÑA 1: General -->
            <v-tab-item>
              <v-row dense class="mt-4">
                <v-col cols="12" md="3">
                  <v-select
                    v-model="item.typeid"
                    label="Tipo Doc"
                    :items="dynamicSettings.documentTypes"
                    item-value="code"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="item.PartyIdentification"
                    label="Número ID"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="item.PartyName"
                    label="Nombre Empresa"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
              </v-row>

              <v-row dense class="mt-3">
                <v-col cols="12">
                  <v-autocomplete
                    v-model="item.economic_activity"
                    label="Actividad Económica"
                    :items="commercialActivities"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    hide-details="auto"
                    clearable
                    return-object
                  />
                </v-col>
              </v-row>

              <v-row dense class="mt-3">
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="item.AddressLine"
                    label="Dirección"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="item.Department"
                    label="Departamento"
                    :items="dynamicSettings.departments"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="selectedMunicipality"
                    label="Ciudad"
                    :items="dynamicSettings.municipalities"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                    return-object
                    @change="handleMunicipalityChange"
                  />
                </v-col>
              </v-row>

              <v-row dense class="mt-3">
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="item.client_email"
                    label="Email"
                    :rules="f_email"
                    outlined
                    dense
                    hide-details="auto"
                    type="email"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="item.client_phone"
                    label="Teléfono"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- PESTAÑA 2: Fiscal -->
            <v-tab-item>
              <v-row dense class="mt-4">
                <v-col cols="12" md="6">
                  <v-select
                    v-model="item.type_organization_id"
                    label="Tipo de Persona"
                    :items="dynamicSettings.organizationTypes"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="item.type_regime_id"
                    label="Régimen Fiscal"
                    :items="dynamicSettings.regimeTypes"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
              </v-row>

              <v-row dense class="mt-3">
                <v-col cols="12" md="6">
                  <v-select
                    v-model="item.type_liability_id"
                    label="Responsabilidad"
                    :items="dynamicSettings.liabilityTypes"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="item.inc"
                    label="INC"
                    :items="inc"
                    item-value="id"
                    item-text="name"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
              </v-row>

              <v-row class="mt-4">
                <v-col
                  v-for="vat in dynamicSettings.vatRates"
                  :key="vat.id"
                  cols="6"
                  md="3"
                >
                  <v-card outlined class="text-center pa-2">
                    <div class="text-h6 primary--text">{{ vat.rate }}%</div>
                    <div class="text-caption">{{ vat.name }}</div>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- PESTAÑA 3: Config -->
            <v-tab-item>
              <v-row dense class="mt-4">
                <v-col cols="12" md="4">
                  <v-select
                    v-model="item.Country_IdentificationCode"
                    label="País"
                    :items="availableCountries"
                    item-value="code"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                    @change="handleCountrySelectionChange"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="item.currencyCode"
                    label="Moneda"
                    :items="availableCurrencies"
                    item-value="code"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                    @change="handleCurrencyChange"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="item.environment"
                    label="Ambiente"
                    :items="setting.type_environments || []"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    dense
                    hide-details="auto"
                    prepend-inner-icon="mdi-server"
                  >
                    <template v-slot:selection="{ item }">
                      <div class="d-flex align-center">
                        <v-icon
                          small
                          :color="item.id === '1' ? 'success' : 'warning'"
                          class="mr-2"
                        >
                          {{ item.id === "1" ? "mdi-check-circle" : "mdi-test-tube" }}
                        </v-icon>
                        {{ item.name }}
                      </div>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <!-- Sync Code Switch -->
              <v-row dense class="mt-4">
                <v-col cols="12">
                  <v-card outlined class="pa-3">
                    <v-switch
                      v-model="item.sync_code"
                      label="Modo de envío a DIAN"
                      color="primary"
                      :true-value="1"
                      :false-value="0"
                      hide-details="auto"
                      class="mt-0"
                    >
                      <template v-slot:label>
                        <div>
                          <div class="d-flex align-center">
                            <v-icon
                              left
                              small
                              :color="item.sync_code === 1 ? 'primary' : 'warning'"
                            >
                              {{ item.sync_code === 1 ? "mdi-clock-check" : "mdi-send" }}
                            </v-icon>
                            <span class="ml-2 font-weight-medium">
                              Modo de envío a DIAN:
                              <v-chip
                                small
                                :color="item.sync_code === 1 ? 'primary' : 'warning'"
                                text-color="white"
                                class="ml-2"
                              >
                                {{ item.sync_code === 1 ? "Síncrono" : "Asíncrono" }}
                              </v-chip>
                            </span>
                          </div>
                          <div class="text-caption mt-1 grey--text text--darken-1">
                            <span v-if="item.sync_code === 1">
                              <v-icon x-small color="primary">mdi-check-circle</v-icon>
                              <strong>Síncrono:</strong> Espera respuesta de DIAN con el
                              CUFE antes de continuar
                            </span>
                            <span v-else>
                              <v-icon x-small color="warning">mdi-lightning-bolt</v-icon>
                              <strong>Asíncrono:</strong> Envía a DIAN sin esperar
                              confirmación inmediata
                            </span>
                          </div>
                        </div>
                      </template>
                    </v-switch>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Info Cards -->
              <v-row class="mt-4">
                <v-col cols="12" md="6">
                  <v-alert type="info" outlined icon="mdi-lightbulb-on">
                    <div class="text-subtitle-2 font-weight-medium mb-1">
                      Configuración del Sistema
                    </div>
                    <div class="text-body-2">
                      Estos parámetros determinan cómo se comporta el sistema. El ambiente
                      de "Producción" debe usarse solo cuando la configuración esté
                      completamente validada.
                    </div>
                  </v-alert>
                </v-col>
                <v-col cols="12" md="6">
                  <v-alert type="success" outlined icon="mdi-earth">
                    <div class="text-subtitle-2 font-weight-medium mb-1">
                      Configuración por País: {{ getCurrentCountryName() }}
                    </div>
                    <div class="text-body-2">
                      Las configuraciones de documentos, departamentos y moneda se
                      actualizan automáticamente según el país seleccionado.
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- PESTAÑA 4: Operación -->
            <v-tab-item>
              <v-row dense class="mt-4">
                <v-col cols="12" md="8">
                  <v-select
                    v-model="storeOps.billing_mode"
                    label="Modo de facturación"
                    :items="billingModeOptions"
                    item-value="value"
                    item-text="text"
                    outlined
                    dense
                    hide-details="auto"
                    prepend-inner-icon="mdi-point-of-sale"
                    persistent-hint
                    :hint="currentBillingHint"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn
                    color="primary"
                    block
                    :loading="savingStoreOps"
                    @click="saveStoreOps"
                  >
                    <v-icon left small>mdi-content-save</v-icon>
                    Guardar modo
                  </v-btn>
                </v-col>
              </v-row>

              <v-row dense class="mt-2">
                <v-col cols="12">
                  <v-alert
                    type="info"
                    outlined
                    icon="mdi-information"
                    class="mt-2"
                  >
                    <div class="text-subtitle-2 font-weight-medium mb-1">
                      ¿Qué cambia al elegir un modo?
                    </div>
                    <div class="text-body-2">
                      Tras guardar, el menú de Facturación mostrará solo la opción
                      correspondiente y, al iniciar sesión, el sistema abrirá ese
                      componente por defecto. La <strong>Registradora</strong> es el
                      modo mínimo y no requiere maestro de productos ni inventario,
                      solo categorías configuradas en Settings.
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <!-- Botones de acción -->
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-btn
            color="error"
            outlined
            :disabled="!item.id"
            @click="dialog_confirm = true"
          >
            <v-icon left small>mdi-delete</v-icon>
            Eliminar
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn type="submit" color="primary" elevation="2">
            <v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <!-- Dialog de Confirmación -->
    <v-dialog v-model="dialog_confirm" max-width="480" persistent>
      <v-card class="text-center pa-4" style="border-radius: 16px">
        <v-avatar size="80" color="error" class="mx-auto mb-4">
          <v-icon size="40" color="white">mdi-alert-circle</v-icon>
        </v-avatar>

        <v-card-title class="text-h5 font-weight-bold justify-center mb-2">
          Confirmar Eliminación
        </v-card-title>

        <v-card-text class="text-body-1 grey--text text--darken-1">
          ¿Está seguro que desea eliminar este registro? Esta acción no se puede deshacer
          y perderá toda la información asociada.
        </v-card-text>

        <v-card-actions class="justify-center pt-4">
          <v-btn
            text
            large
            color="grey"
            class="text-none font-weight-medium mr-4"
            @click="dialog_confirm = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="error"
            large
            elevation="2"
            class="text-none font-weight-bold"
            @click="delete_item"
          >
            <v-icon left>mdi-delete</v-icon>
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading Dialog -->
    <v-dialog v-model="loading_status" hide-overlay persistent width="320">
      <v-card class="text-center pa-6" style="border-radius: 16px">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
          width="4"
          class="mb-4"
        ></v-progress-circular>

        <v-card-title class="text-h6 font-weight-bold justify-center">
          {{ loadingStatus.title }}
        </v-card-title>

        <v-card-text class="text-body-2 grey--text">
          {{ loadingStatus.text }}
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar Mejorado -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
      class="modern-snackbar"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-3" :color="snackbar.color === 'error' ? 'white' : 'white'">
          {{ snackbar.color === "error" ? "mdi-alert-circle" : "mdi-check-circle" }}
        </v-icon>
        <span class="font-weight-medium">{{ snackbar.text }}</span>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          small
          color="white"
          v-bind="attrs"
          @click="snackbar.show = false"
          class="text-none"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { webserver } from "../../services/webserver.js";
import { fe_ws } from "../../services/webserver.js"; // 🇨🇴 Para Gateway DIAN
import createCompany from "../../utils/createCompany.js";
import settings from "../../utils/settings.js";
import countryUtils from "../../utils/countryUtils.js";

export default {
  name: "Company",
  components: {},

  mounted() {
    this.loadDynamicSettings();
    this.get_colombia_municipalities();
    this.get_items();
    this.loadStoreOps();

    // Escuchar cambios de país para actualizar configuraciones
    window.addEventListener("countrySettingsChanged", this.handleCountryChange);
  },

  beforeDestroy() {
    window.removeEventListener("countrySettingsChanged", this.handleCountryChange);
  },

  data() {
    return {
      valid: false,
      activeTab: 0,
      loading_status: false,
      dialog_confirm: false,

      item: {
        ...createCompany(),
        economic_activity: null,
        Country_IdentificationCode: "CO", // Colombia por defecto
      },

      selectedMunicipality: null,

      // Configuraciones dinámicas por país
      dynamicSettings: {
        documentTypes: [],
        departments: [],
        municipalities: [],
        liabilityTypes: [],
        organizationTypes: [],
        regimeTypes: [],
        vatRates: [],
      },

      // DIAN para Colombia
      dianSync: {
        synchronized: false,
        searching: false,
        gatewayData: null,
        lastSync: null,
      },

      // Países disponibles
      availableCountries: [],

      availableCurrencies: [
        { code: "EUR", name: "Euro (€)" },
        { code: "USD", name: "Dólar Americano ($)" },
        { code: "COP", name: "Peso Colombiano (COP)" },
        { code: "MXN", name: "Peso Mexicano (MX$)" },
        { code: "GBP", name: "Libra Esterlina (£)" },
        { code: "CAD", name: "Dólar Canadiense (CAD)" },
      ],

      commercialActivities: [
        { id: "4711", name: "Tiendas de barrio" },
        { id: "4721", name: "Supermercados" },
        { id: "4771", name: "Ropa y calzado" },
        { id: "4772", name: "Farmacias" },
        { id: "5610", name: "Restaurantes" },
        { id: "6910", name: "Servicios legales" },
        { id: "8610", name: "Servicios médicos" },
        { id: "9499", name: "Otros servicios" },
      ],

      lstSync: [
        { name: "Habilitado", id: "1" },
        { name: "Deshabilitado", id: "0" },
      ],

      inc: [
        { name: "Responsable del INC", id: "1" },
        { name: "No Responsable", id: "0" },
      ],

      f_required: [(v) => !!v || "Campo obligatorio"],
      f_email: [
        (v) => !!v || "Email obligatorio",
        (v) => /.+@.+\..+/.test(v) || "Email inválido",
      ],
      f_phone: [(v) => !v || /^\+?[\d\s\-()]{7,15}$/.test(v) || "Teléfono inválido"],

      reg_delete: null,
      loadingStatus: { title: "Procesando", text: "Conectando..." },
      setting: {},
      snackbar: { show: false, text: "", color: "success", timeout: 4000 },

      storeOps: { billing_mode: "register" },
      savingStoreOps: false,
      billingModeOptions: [
        {
          value: "register",
          text: "Registradora — tienda mostrador (precio + categoría)",
        },
        {
          value: "formal",
          text: "Facturación electrónica formal (con maestro e inventario)",
        },
        {
          value: "pos",
          text: "POS supermercado (barcode, cobro inmediato)",
        },
        {
          value: "restaurant",
          text: "POS restaurante (cuenta abierta / comandas)",
        },
      ],
    };
  },

  computed: {
    currentBillingHint() {
      const opt = this.billingModeOptions.find(
        (o) => o.value === this.storeOps.billing_mode
      );
      return opt ? opt.text : "";
    },
  },

  methods: {
    loadDynamicSettings() {
      this.setting = settings();
      // Usar país seleccionado en el formulario o Colombia por defecto
      const countryCode = this.item.Country_IdentificationCode || "CO";
      this.dynamicSettings = {
        documentTypes: countryUtils.getDocumentTypes(countryCode),
        departments: countryUtils.getDepartments(countryCode),
        municipalities: [], // Se cargarán desde la BD con get_colombia_municipalities
        liabilityTypes: countryUtils.getLiabilityTypes(countryCode),
        organizationTypes: countryUtils.getOrganizationTypes(countryCode),
        regimeTypes: countryUtils.getRegimeTypes(countryCode),
        vatRates: countryUtils.getVatRates(countryCode),
      };
      this.availableCountries = countryUtils.getAvailableCountries();
    },

    handleCountrySelectionChange(newCountryCode) {
      // Actualizar el país en el item primero
      this.item.Country_IdentificationCode = newCountryCode;
      // Luego actualizar las configuraciones dinámicas
      countryUtils.updateComponentsForCountry(newCountryCode);
      this.loadDynamicSettings();
      this.item.currencyCode = countryUtils.getDefaultCurrency(newCountryCode);
      this.showNotification(`País cambiado a ${newCountryCode}`, "success");
    },

    handleCurrencyChange(currencyCode) {
      this.showNotification(`Moneda cambiada a ${currencyCode}`, "info");
    },

    handleMunicipalityChange(municipality) {
      if (municipality && typeof municipality === "object") {
        this.item.CityName = municipality.name;
        this.item.city_code = parseInt(municipality.id);
      }
    },

    showNotification(text, color = "success") {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },

    loadStoreOps() {
      const qry = {
        store: window.store.store_id,
        table: "stores",
        filters: [
          { field: "store_id", operator: "=", value: window.store.store_id },
        ],
      };
      webserver("get_dataTable", qry, (data) => {
        if (data && data[0] && data[0].billing_mode) {
          this.storeOps.billing_mode = data[0].billing_mode;
        } else {
          this.storeOps.billing_mode = "register";
        }
      });
    },

    saveStoreOps() {
      const mode = this.storeOps.billing_mode || "register";
      this.savingStoreOps = true;

      const qry = {
        store: window.store.store_id,
        table: "stores",
        data: [
          {
            store_id: window.store.store_id,
            billing_mode: mode,
          },
        ],
      };

      webserver("put_dataTable", qry, () => {
        this.savingStoreOps = false;
        if (window.store) window.store.billing_mode = mode;
        this.$store.dispatch("setBillingMode", mode);
        this.showNotification("Modo de facturación actualizado", "success");
      });
    },

    item_submit(e) {
      e.preventDefault();
      this.valid = this.$refs.itemForm.validate();

      if (this.valid) {
        let itemToSubmit = { ...this.item };

        if (
          itemToSubmit.economic_activity &&
          typeof itemToSubmit.economic_activity === "object"
        ) {
          itemToSubmit.economic_activity = itemToSubmit.economic_activity.id;
        }

        const qry = {
          store: window.store.store_id,
          table: "f_companies",
          data: [itemToSubmit],
        };

        this.loadingStatus = { title: "Guardando", text: "Actualizando..." };
        this.loading_status = true;

        webserver("put_dataTable", qry, () => {
          this.loading_status = false;
          this.showNotification("Información guardada correctamente", "success");
        });
      } else {
        this.showNotification("Complete todos los campos obligatorios", "error");
      }
    },

    delete_item() {
      this.dialog_confirm = false;
      const record = this.reg_delete;

      this.loading_status = true;
      this.loadingStatus = { title: "Eliminando", text: "Eliminando registro..." };

      const qry = {
        table: "f_company",
        filters: { account: this.$store.state.profile.account, code: record },
      };

      webserver("delete_record", qry, () => {
        this.reg_delete = null;
        this.loading_status = false;
        this.showNotification("Registro eliminado correctamente", "success");
        this.item = {
          ...createCompany(),
          economic_activity: null,
          store_code: window.store.store_id,
        };
        this.$emit("refresh", true);
      });
    },

    get_items() {
      const qry = {
        store: window.store.store_id,
        table: "f_companies",
        filters: [{ field: "store_code", operator: "=", value: window.store.store_id }],
      };

      this.loadingStatus = { title: "Cargando", text: "Obteniendo información..." };
      this.loading_status = true;

      webserver("get_dataTable", qry, (data) => {
        this.loading_status = false;
        this.item.store_code = window.store.store_id;

        if (data.length > 0) {
          const backendData = data[0];
          let economicActivity = null;

          if (backendData.economic_activity) {
            economicActivity =
              this.commercialActivities.find(
                (activity) => activity.id === backendData.economic_activity
              ) || backendData.economic_activity;
          }

          this.item = {
            ...this.item,
            ...backendData,
            economic_activity: economicActivity,
            currencyCode: backendData.currencyCode || countryUtils.getDefaultCurrency(),
            sync_code: parseInt(backendData.sync_code) || 0, // Asegurar que sync_code sea entero
          };

          // Cargar la ciudad seleccionada si existe
          if (backendData.city_code) {
            this.selectedMunicipality = this.dynamicSettings.municipalities.find(
              (m) =>
                parseInt(m.id) === parseInt(backendData.city_code) ||
                m.code === String(backendData.city_code)
            );
          }
        } else {
          this.item.currencyCode = countryUtils.getDefaultCurrency();
        }
      });
    },

    get_colombia_municipalities() {
      const qry = {
        store: window.store.store_id,
        table: "settings",
        filters: [{ field: "tableName", operator: "=", value: "municipalities" }],
      };

      this.loadingStatus = { title: "Cargando", text: "Obteniendo municipios..." };
      this.loading_status = true;

      fe_ws("get_table", qry, (data) => {
        this.loading_status = false;
        if (data && Array.isArray(data)) {
          // Mapear los datos al formato esperado
          this.dynamicSettings.municipalities = data.map((municipality) => ({
            code: municipality.code,
            name: municipality.name,
            id: municipality.id,
          }));

          // Si ya hay un city_code guardado, buscar y seleccionar el municipio
          if (this.item.city_code) {
            this.selectedMunicipality = this.dynamicSettings.municipalities.find(
              (m) =>
                parseInt(m.id) === parseInt(this.item.city_code) ||
                m.code === String(this.item.city_code)
            );
          }
        }
      });
    },

    // Métodos DIAN simplificados
    searchAndSyncFromDIAN() {
      if (!this.item.PartyIdentification) {
        this.showNotification("Ingrese el NIT primero", "warning");
        return;
      }
      this.dianSync.searching = true;
      fe_ws("admin_company", { nit: this.item.PartyIdentification }, (response) => {
        this.dianSync.searching = false;
        if (response && (response.success === true || response.id)) {
          this.dianSync.gatewayData = response.data || response;
          this.dianSync.synchronized = true;
          this.dianSync.lastSync = new Date().toLocaleString("es-CO");
          this.showNotification("Datos sincronizados con DIAN", "success");
        } else {
          this.showNotification("NIT no encontrado en DIAN", "info");
          this.dianSync.synchronized = false;
        }
      });
    },

    getCurrentCountryName() {
      const country = this.availableCountries.find(
        (c) => c.code === this.item.Country_IdentificationCode
      );
      return country ? country.name : "No definido";
    },
  },
};
</script>

<style scoped>
.company-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.v-card {
  border-radius: 12px;
}

.v-btn {
  text-transform: none;
}
</style>
